import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { ExcelqandaService } from '../excelqanda.service';
import { AlertPopup } from 'app/app.config';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { saveAs as importedSaveAs } from "file-saver";
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { LlmService } from 'app/services/llm.service';
import { StaffRoomService } from 'app/components/staff-room/staff-room.service';
import { ChatService } from 'app/components/chat-list/chat.service';
@Component({
  selector: 'app-excel-upload',
  templateUrl: './excel-upload.component.html',
  styleUrls: ['./excel-upload.component.scss']
})
export class ExcelUploadComponent {

  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  showPaginateSpinner: boolean = false;

  excelSheetForm: FormGroup = new FormGroup({});
  sheetDataForm: FormGroup = new FormGroup({});
  sheetslist = ['sheet 1', 'sheet 2', 'sheet 3', 'sheet 4'];
  showsheetform: boolean = false;
  showDropdown: boolean = false;
  downloadFilename: any;
  sheetDataList: any = [];
  showsheetDataList: boolean = false;
  elibraryList: any = [];
  selectedClassList: any;
  ClassListData: any[] = [];
  Class_id: any;

  // Document list properties
  documentList: any[] = [];
  showDocumentList: boolean = false;
  documentListLoading: boolean = false;
  isUserRole: any = "";
  selectedDocuments: Set<string> = new Set();
  isModelType: any = "";
  selectAll: boolean = false;
  @ViewChild('elibraryFileInput') elibraryFileInput: ElementRef;

  // History properties
  showHistory: boolean = false;
  historyList: any[] = [];
  filteredHistoryList: any[] = [];
  historyLoading: boolean = false;
  historySearchText: string = '';
  constructor(private excelservice: ExcelqandaService, private alert: AlertPopup, private fb: FormBuilder, private llmService: LlmService, private confirmService: ConfirmationDialogService, private staffRoomService: StaffRoomService, private chatService: ChatService) {

  }

  ngOnInit() {
    // Initialize user role
    this.isUserRole = window.localStorage.getItem('user_role');
    this.isUserRole = this.isUserRole ? parseInt(this.isUserRole.replace(/\"/g, "")) : 0;

    this.excelSheetForm = this.fb.group({
      file_name: '',
      sheets: this.fb.array([]),
    });

    this.sheetDataForm = this.fb.group({
      file_name: '',
      sheet_list: this.fb.array([
        this.fb.group({
          sheet_name: '',
          sheet_data: this.fb.array([
            this.fb.group({
              question: '',
              answer: ''
            })
          ])
        })
      ]),
    });
    // this.generateSheetForm();
    this.getllmUserInfo();
    this.loadHistory();

    // this.showsheetDataList = true;
    //  let result = this.getmockData();
    //   this.sheetDataList = result['data']; 
  }

  generateSheetForm() {
    let i = 0;
    console.log(this.sheetslist);
    while (i < this.sheetslist.length) {
      this.addSkills();
      this.skills.controls[i]['controls']["sheet_name"].setValue(this.sheetslist[i]['sheet_name']);
      i++;
    }

  }

  get skills() {
    return this.excelSheetForm.get("sheets") as FormArray;
  }

  get sheetlist() {
    return this.sheetDataForm.get('sheet_list') as FormArray;
  }



  newSkill(): FormGroup {
    return this.fb.group({
      sheet_name: ['', Validators.required],
      question_field: ['', Validators.required],
      answer_field: ['', Validators.required],
    })
  }

  addSkills() {
    this.skills.push(this.newSkill());
  }

  removeSkill(i: number) {
    this.confirmService.openConfirmDialog('', {
      title: 'Confirmation',
      message: 'Are you sure, you want to remove?',
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (data: any) => {
        if (data) {
          this.skills.removeAt(i);
          if (this.skills.controls.length == 0) {
            this.showsheetform = false;
          }
        }
      }
    });
  }

  getColumns(i: number) {
    return this.sheetslist[i]['columns'][0];
  }


  chooseUploadFile(event: any) {
    this.showPaginateSpinner = true;
    const files = event.target.files;
    let fileLLMformData = new FormData();
    fileLLMformData.append('file', files[0], files[0].name);
    fileLLMformData.append('client_id', localStorage.getItem("company_id"))
    this.excelservice.uploadSummaryPdf(fileLLMformData).subscribe((res: any) => {
      this.showPaginateSpinner = false;
      if (res['sheets'].length > 0) {
        this.elibraryFileInput.nativeElement.value = null;
        // for(const [key,value]  of  res['sheets'].map((item:any)=>Object.entries(item))){
        // //     if(key=="sheet_name"){
        //       this.sheetslist.push(value);
        //     }
        // }
        this.sheetslist = res['sheets'];
        this.excelSheetForm.controls['file_name'].setValue(res['file_name']);
        this.showDropdown = true;
        this.generateSheetForm();
        this.showsheetform = true;
      }



    }, (error: HttpErrorResponse) => {
      this.alert.showAlertMessage({ "message": "Unable to Upload file" });
      this.showPaginateSpinner = false;
    });
  }

  toggleSheet(index: number): void {
    this.sheetDataList.forEach((item, i) => {
      item.expanded = i === index ? !item.expanded : false;
    });
  }

  onSubmit() {
    console.log(this.selectedDocuments.size);

    if (this.selectedDocuments.size === 0) {
      this.alert.showAlertMessage({ message: "Please select a document" });
      return;
    }

    if (!this.excelSheetForm.valid) {
      this.alert.showAlertMessage({ message: "Fill all required fields" });
      return;
    }

    this.showPaginateSpinner = true;
    this.alert.showAlertMessage({ message: "Data is processing" });

    const payload = {
      ...this.excelSheetForm.value,
      class_id: this.Class_id,
      model_type: this.isModelType,
      doc_id: Array.from(this.selectedDocuments),
      client_id: localStorage.getItem("company_id"),
      "x-auth-token": localStorage.getItem("llm_token"),
    };

    this.excelservice.getSheetData(payload).subscribe({
      next: (result: any) => {
        this.showPaginateSpinner = false;

        if (result?.data?.length > 0) {
          this.excelSheetForm.reset();
          this.showsheetDataList = true;
          this.downloadFilename = result.file_name;
          this.sheetDataList = result.data;
          this.showsheetform = false;

          this.excelSheetForm.reset();
          
          // Add to history
          this.addToHistory(result);
          this.alert.showAlertMessage({ message: "Data loaded successfully" });
        } else {
          this.alert.showAlertMessage({ message: "No data found in sheet" });
        }
      },
      error: (err) => {
        this.showPaginateSpinner = false;
        console.error(err);
        this.alert.showAlertMessage({ message: "Failed to process data" });
      }
    });
  }



  downloadSheet() {
    let fileLLMformData = new FormData();

    fileLLMformData.append('file_name', this.downloadFilename);
    fileLLMformData.append('client_id', localStorage.getItem("company_id"))
    this.excelservice.downloadSheet(fileLLMformData).subscribe((res_blob: any) => {
      let d = new Date();
      var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
        d.getHours() + "-" + d.getMinutes();
      importedSaveAs(res_blob, datestring + ".xlsx");
      this.alert.showAlertMessage({ 'message': 'Source document download', 'type': 2 });
    });
  }

  closeSheet() {
    this.showsheetDataList = false;
    this.showsheetform = false; // optional – if you want to return to the form view
    this.showPaginateSpinner = false;

    this.excelSheetForm.reset();
    this.selectedClassList = "";
    this.documentList = [];
    this.selectedDocuments.clear();

    this.sheetDataList = [];
    this.downloadFilename = "";
    this.showDropdown = false;
    this.skills.clear();
  }


  getllmUserInfo() {
    this.llmService.llmUserInfo().subscribe({
      next: (response: any) => {
        this.llmService.LLM_classes = response['class_access'];
        this.getElibrary().then((result: any) => {

          this.elibraryList = result;
        });
      },
      error: (error: HttpErrorResponse) => {

      }
    })
  }

  async getElibrary() {
    return new Promise((resolve, reject) => {
      const payLoad = {
        offset: 0,
        limit: 25,
        search: '',
        sort: 'time',
        data_type: true
      };

      this.staffRoomService.getClassList(payLoad).subscribe(
        (response: any) => {
          let temp_list = [];
          let elibraryList = [];
          if (response.hasOwnProperty('result')) {
            temp_list = response['result'];
            this.ClassListData = response['result'];
          } else {
            temp_list = response['chatList'];
            this.ClassListData = response['chatList'];
          }

          if (this.llmService.LLM_classes.length > 0) {

            this.llmService.LLM_classes.map(class_id => {
              temp_list.map(lib_list => {
                if (lib_list['group_id'] == class_id) {
                  elibraryList.push(lib_list);
                }
              });

            });
          }
          resolve(elibraryList);


        },
        (error) => {
          reject([]);
        });

    });
  }

  dropdownSelectedClass(event: any) {


    this.Class_id = event.value['group_id'];
    this.selectedClassList = event.value;
    this.isModelType = event.value['model_type'];

    // Load documents for the selected class
    this.getDocumentList();
  }

  getDocumentList() {
    if (!this.Class_id) {
      this.documentList = [];
      this.showDocumentList = false;
      return;
    }

    this.documentListLoading = true;
    this.showDocumentList = true;

    const payLoad = {
      offset: 0,
      limit: 25,
      groupId: this.Class_id,
      is_doc_section: true
    };

    this.chatService.getMessageAttachments(payLoad).subscribe(
      response => {
        const documents = response['recordList'] || [];


        // Initialize with views count (assuming it exists or defaulting to 1)
        this.documentList = documents.map((doc: any) => ({
          ...doc,
          views: doc.views || 1
        }));
        this.documentListLoading = false;
      },
      error => {
        this.alert.showAlertMessage(error.error || 'Error loading documents');
        this.documentListLoading = false;
        this.documentList = [];
      }
    );
  }

  toggleDocumentSelection(document: any) {
    const id = document.llmfile_uuid || document.download_url;

    console.log(document);


    if (this.selectedDocuments.has(id)) {
      this.selectedDocuments.delete(id);
    } else {
      this.selectedDocuments.add(id);
    }
    this.updateSelectAllState();
  }

  toggleSelectAll() {
    if (this.selectAll) {
      this.selectedDocuments.clear();
    } else {
      this.documentList.forEach(doc => {
        const id = doc.llmfile_uuid || doc.download_url;
        this.selectedDocuments.add(id);
      });
    }
    this.selectAll = !this.selectAll;
  }

  updateSelectAllState() {
    this.selectAll = this.selectedDocuments.size === this.documentList.length && this.documentList.length > 0;
  }

  isDocumentSelected(document: any): boolean {
    const id = document.llmfile_uuid || document.download_url;
    return this.selectedDocuments.has(id);
  }

  downloadDocument(document: any) {
    if (document.download_url) {
      window.open(document.download_url, '_blank');
    }
  }

  getDocumentTitle(item: any): string {
    if (item.message && item.message !== 'undefined') {
      return item.message.replace(/<[^>]*>/g, ''); // Remove HTML tags
    }
    return item.file_path || 'No Title';
  }

  ngOnDestroy() {
    this.showsheetDataList = false;
    this.showsheetform = false;
  }

  // History Methods
  toggleHistory() {
    this.showHistory = !this.showHistory;
    if (this.showHistory && this.historyList.length === 0) {
      this.loadHistory();
    }
  }

  loadHistory() {
    this.historyLoading = true;
    const clientId = localStorage.getItem("company_id");
    if (!clientId) {
      this.historyLoading = false;
      this.historyList = [];
      this.filteredHistoryList = [];
      return;
    }

    const fileLLMformData = new FormData();
    fileLLMformData.append('client_id', clientId);

    this.excelservice.getFiles(fileLLMformData).subscribe(
      (response: any) => {
        this.historyLoading = false;
        if (response && response.Files && Array.isArray(response.Files)) {
          this.historyList = response.Files.map((fileName: string) => ({
            file_name: fileName,
            class_name: 'Unknown',
            class_id: '',
            created_at: new Date().toISOString(),
            status: 'completed',
            sheet_count: 0,
            sheet_data: [],
            download_filename: fileName
          }));
        } else {
          this.historyList = [];
        }
        this.filteredHistoryList = [...this.historyList];
      },
      (error: HttpErrorResponse) => {
        this.historyLoading = false;
        this.historyList = [];
        this.filteredHistoryList = [];
        console.error('Error loading history:', error);
      }
    );
  }

  filterHistory() {
    if (!this.historySearchText || this.historySearchText.trim() === '') {
      this.filteredHistoryList = [...this.historyList];
    } else {
      const searchTerm = this.historySearchText.toLowerCase().trim();
      this.filteredHistoryList = this.historyList.filter(item => {
        const fileName = (item.file_name || '').toLowerCase();
        const className = (item.class_name || '').toLowerCase();
        return fileName.includes(searchTerm) || className.includes(searchTerm);
      });
    }
  }

  addToHistory(result: any) {
    // Reload history from API after successful upload
    // The file is already saved on the server, so we just refresh the list
    this.loadHistory();
  }

  viewHistoryItem(item: any) {
    if (item.sheet_data && item.sheet_data.length > 0) {
      this.sheetDataList = item.sheet_data;
      this.downloadFilename = item.download_filename || item.file_name;
      this.showsheetDataList = true;
      this.showHistory = false;
    } else {
      // Download the file if no sheet data is available
      const fileName = item.download_filename || item.file_name;
      if (fileName) {
        this.downloadHistoryFile(fileName);
      } else {
        this.alert.showAlertMessage({ "message": "No data available for this item" });
      }
    }
  }

  downloadHistoryFile(fileName: string) {
    const clientId = localStorage.getItem("company_id");
    if (!clientId || !fileName) {
      this.alert.showAlertMessage({ "message": "Missing required information to download file" });
      return;
    }

    let fileLLMformData = new FormData();
    fileLLMformData.append('file_name', fileName);
    fileLLMformData.append('client_id', clientId);

    this.excelservice.downloadSheet(fileLLMformData).subscribe(
      (res_blob: any) => {
        let d = new Date();
        var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
          d.getHours() + "-" + d.getMinutes();
        importedSaveAs(res_blob, datestring );
        this.alert.showAlertMessage({ 'message': 'File downloaded successfully', 'type': 2 });
      },
      (error: HttpErrorResponse) => {
        this.alert.showAlertMessage({ "message": error.error?.message || "Error downloading file" });
      }
    );
  }

  downloadHistoryItem(item: any) {
    if (item.download_filename || item.file_name) {
      this.downloadFilename = item.download_filename || item.file_name;
      this.downloadSheet();
    } else {
      this.alert.showAlertMessage({ "message": "File not available for download" });
    }
  }

  deleteHistoryItem(item: any, index: number) {
    this.confirmService.openConfirmDialog('', {
      title: 'Delete History Item',
      message: 'Are you sure you want to delete this history item?',
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (data: any) => {
        if (data) {
          const clientId = localStorage.getItem("company_id");
          const fileName = item.file_name || item.download_filename || item;

          if (!clientId || !fileName) {
            this.alert.showAlertMessage({ "message": "Missing required information to delete file" });
            return;
          }

          const fileLLMformData = new FormData();
          fileLLMformData.append('file_name', fileName);
          fileLLMformData.append('client_id', clientId);

          this.excelservice.deleteFiles(fileLLMformData).subscribe(
            (response: any) => {
              // Remove from local list
              const actualIndex = this.historyList.findIndex(h => h === item);
              if (actualIndex !== -1) {
                this.historyList.splice(actualIndex, 1);
              }
              this.filterHistory();
              this.alert.showAlertMessage({ "message": "History item deleted successfully", 'type': 2 });
            },
            (error: HttpErrorResponse) => {
              this.alert.showAlertMessage({ "message": error.error?.message || "Error deleting file" });
            }
          );
        }
      }
    });
  }




  getmockData() {
    let response: any = {
      "data": [
        {
          "sheet_data": [
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The document provides information about three policies proposed by ABC Corp for Absence Blueprint Policy Document, effective from June 2025. Here are the names of the policies mentioned in the context:\n\n1. Short Term Disability Policy (STD)\n2. Paid Parental Leave Policy (PPL)\n\nThe Short Term Disability (STD) policy provides a benefit of up to 26 weeks of pay when an employee is out of work due to a disability. The policy covers 100% of your pay for 6 or 8 weeks, depending on your delivery type, during pregnancy leaves. It requires a one-week unpaid waiting period before benefits will begin, and employees are allowed to use PTO during the waiting period.\n\nThe Paid Parental Leave (PPL) policy allows employees to bond with a newborn, newly adopted or foster child within 12 months of the event. The lookback period is per event. Employees can take time off in one-week increments and can top up with PTO/Sick. If an employee has been with the company for more than one year, they will receive 6 weeks at 100% of pay, followed by 6 weeks at 50% of pay. If an employee has less than one year of service, they will receive 6 weeks at 100% of pay. The waiting period for PPL is none for pregnancy leaves. Employees must work 30 hours or more per week to be eligible for this policy.",
              "question": "Listout some policies Name"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The client code provided in the context is 1234.",
              "question": "what is the client code?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "Based on the provided context, it appears that Short Term Disability (STD) does not have both Pay and Job Protection explicitly mentioned. However, the context suggests that certain leaves or benefits may include both pay and job protection. For instance, Paid Parental Leave (PPL) offers both pay and job protection for eligible employees who take leave to bond with a new child.\n\nIn the case of Short Term Disability, it is not explicitly stated whether it includes job protection. However, it does provide pay replacement benefits during an employee's disability. The context mentions that any approval of leave or benefits is subject to applicable law and may also be subject to the company's policies and supporting medical documentation. Therefore, it would be best to consult with the Benefits team at SSI (benefits@ssi.samsung.com) for more detailed information regarding Short Term Disability and its specific provisions related to pay and job protection.",
              "question": "Is Short Term Disability have both Pay and Job Protection?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The Waiting Period for Short Term Disability (STD) is a one-week unpaid waiting period before benefits will begin. This is stated in the context provided: \"STD requires a one week unpaid waiting period before benefits will begin.\"",
              "question": "what is the Waiting Period for Short Term Disability?"
            }
          ],
          "sheet_name": "Sheet1"
        },
        {
          "sheet_data": [
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The document provides information about three policies proposed by ABC Corp for Absence Blueprint Policy Document, effective from June 2025. Here are the names of the policies mentioned in the context:\n\n1. Short Term Disability Policy (STD)\n2. Paid Parental Leave Policy (PPL)\n\nThe Short Term Disability (STD) policy provides a benefit of up to 26 weeks of pay when an employee is out of work due to a disability. The policy covers 100% of your pay for 6 or 8 weeks, depending on your delivery type, during pregnancy leaves. It requires a one-week unpaid waiting period before benefits will begin, and employees are allowed to use PTO during the waiting period.\n\nThe Paid Parental Leave (PPL) policy allows employees to bond with a newborn, newly adopted or foster child within 12 months of the event. The lookback period is per event. Employees can take time off in one-week increments and can top up with PTO/Sick. If an employee has been with the company for more than one year, they will receive 6 weeks at 100% of pay, followed by 6 weeks at 50% of pay. If an employee has less than one year of service, they will receive 6 weeks at 100% of pay. The waiting period for PPL is none for pregnancy leaves. Employees must work 30 hours or more per week to be eligible for this policy.",
              "question": "Listout some policies Name"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The client code provided in the context is 1234.",
              "question": "what is the client code?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "Based on the provided context, it appears that Short Term Disability (STD) does not have both Pay and Job Protection explicitly mentioned. However, the context suggests that certain leaves or benefits may include both pay and job protection. For instance, Paid Parental Leave (PPL) offers both pay and job protection for eligible employees who take leave to bond with a new child.\n\nIn the case of Short Term Disability, it is not explicitly stated whether it includes job protection. However, it does provide pay replacement benefits during an employee's disability. The context mentions that any approval of leave or benefits is subject to applicable law and may also be subject to the company's policies and supporting medical documentation. Therefore, it would be best to consult with the Benefits team at SSI (benefits@ssi.samsung.com) for more detailed information regarding Short Term Disability and its specific provisions related to pay and job protection.",
              "question": "Is Short Term Disability have both Pay and Job Protection?"
            },
            {
              "answer": "",
              "question": ""
            },
            {
              "answer": "The Waiting Period for Short Term Disability (STD) is a one-week unpaid waiting period before benefits will begin. This is stated in the context provided: \"STD requires a one week unpaid waiting period before benefits will begin.\"",
              "question": "what is the Waiting Period for Short Term Disability?"
            }
          ],
          "sheet_name": "Sheet2"
        }
      ],
      "file_name": "ABC_Crop_1760763412563.xlsx"
    }

    return response;
  }


}